module.exports = __webpack_public_path__ + "img/peanut.ff1c5e99.svg";